<div #mapContainer class="map-container" [style.height]="height" [style.width]="width"></div>
